import { render, staticRenderFns } from "./PreferenceAccountSalesPurchase.vue?vue&type=template&id=877cfa62&"
import script from "./PreferenceAccountSalesPurchase.vue?vue&type=script&lang=ts&"
export * from "./PreferenceAccountSalesPurchase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('877cfa62')) {
      api.createRecord('877cfa62', component.options)
    } else {
      api.reload('877cfa62', component.options)
    }
    module.hot.accept("./PreferenceAccountSalesPurchase.vue?vue&type=template&id=877cfa62&", function () {
      api.rerender('877cfa62', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Preference/PreferenceAccountSalesPurchase.vue"
export default component.exports